const config = {
    gatsby: {
        pathPrefix: "/",
        siteUrl: "https://knowledge.evinced.com",
        gaTrackingId: process.env.GA_TRACK_ID
    },
    header: {
        logo: "",
        logoLink: "/",
        title: "Digital Accessibility Knowledge Base",
        githubUrl: "",
        helpUrl: "",
        tweetText: "Evinced, Inc.'s Accessibility Knowledge Base",
        links: [{ text: "", link: "" }],
        search: {
            enabled: true,
            // Set GATSBY_ALGOLIA_INDEX_NAME (e.g. "Pages_dev") to build against a
            // test index; production uses "Pages".
            indexName: process.env.GATSBY_ALGOLIA_INDEX_NAME || "Pages",
            algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
            algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
            algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY
        }
    },
    footer: {
        links: [
            { text: "Knowledge Base", link: "/" },
            { text: "Blog", link: "https://www.evinced.com/blog/" },
            { text: "About us", link: "https://www.evinced.com/about" }
        ]
    },
    sidebar: {
        forcedNavOrder: [
            "/web",
            "/mobile",
            "/a11y-essentials",
            "/glossary"
        ],
        collapsedNav: [
            "/web",
            "/web/web-validations",
            "/web/ui-patterns",
            "/mobile",
            "/mobile/mobile-validations",
            "/a11y-essentials"
        ],
        links: [
            { text: "Evinced, Inc.", link: "https://evinced.com" },
            { text: "Blog", link: "https://evinced.com/blog" }
        ],
        frontline: false,
        ignoreIndex: true,
        ignoreSections: []
    },
    siteMetadata: {
        title: "Accessibility Knowledge Base | Evinced, Inc.",
        description:
            "An accessibility Knowledge Base for the Evinced, Inc. accessibility tests suite",
        ogImage: null,
        docsLocation: "https://github.com/GetEvinced/evinced-kb",
        favicon: "../favicon/Evinced_logo_symbol_left.png"
    }
};

module.exports = config;
